export const ASSOCIATE_USERS_UNIT = '[user/unit] Associate users to a unit';
export const ASSOCIATE_USER_UNITS = '[user/unit] Associate user to units';
export const USER_UNIT_ERROR = '[user/unit] User/unit error';

export const associateUsersUnit = (values, navigate, previous) => ({
  type: ASSOCIATE_USERS_UNIT,
  payload: values,
  navigate: navigate,
  previous: previous,
});
export const associateUserUnits = (values, navigate, previous) => ({
  type: ASSOCIATE_USER_UNITS,
  payload: values,
  navigate: navigate,
  previous: previous,
});
export const userUnitError = (values, navigate, previous) => ({
  type: USER_UNIT_ERROR,
  payload: values,
  navigate: navigate,
  previous: previous,
});
